module.exports = __webpack_public_path__ + "static/media/apple-iphone12pro-silver-portrait.834ed4b7.png";